<template>
  <div class="Architecture">

    <!-- Masthead -->
    <SurveyMasthead
      title="Architecture"
      subtitle="Select Projects."
      srcImage="/assets/other/architecture/mast-icon-arch-354.png"
      largeImage="/assets/other/architecture/mast-icon-arch-708.png"
      :srcSize="354"
      bgColour="#00A2CB" />

    <!-- Project Details -->
    <div class="details">

      <!-- Villa -->
      <ContentSection title="Prairie Villa" :centered="true">
        <p>A contemporary reinterpretation of the classic Italian Villa, set in the context of the Canadian prairie. The design was informed by the history and geometry of land parcels handed out to 19th and 20th century settlers.</p>

        <ProjectImage
          srcImage="/assets/other/architecture/villa-1-900.jpg"
          largeImage="/assets/other/architecture/villa-1-1800.jpg"
          :canZoom="true" />

        <ProjectImage
          srcImage="/assets/other/architecture/villa-elevation-900.jpg"
          largeImage="/assets/other/architecture/villa-elevation-1800.jpg"
          :canZoom="true" />

        <ProjectImage
          srcImage="/assets/other/architecture/villa-plan-900.jpg"
          largeImage="/assets/other/architecture/villa-plan-1800.jpg"
          :canZoom="true" />
      </ContentSection> 

      <!-- Spitalfields -->
      <ContentSection title="Spitalfields Church Revitalization" :centered="true">
        <p>A proposal to revitalize a run down church in the Spitalfields district of East London. It envisioned transforming the unused chrurch into a community, media and performing arts space.</p>

        <ProjectImage
          srcImage="/assets/other/architecture/spitalfields-side-900.jpg"
          largeImage="/assets/other/architecture/spitalfields-side-1800.jpg"
          :canZoom="true" />

        <ProjectImage
          srcImage="/assets/other/architecture/spitalfields-iso-900.jpg"
          largeImage="/assets/other/architecture/spitalfields-iso-1800.jpg"
          :canZoom="true" />

        <ProjectImage
          srcImage="/assets/other/architecture/spitalfields-plan-900.jpg"
          largeImage="/assets/other/architecture/spitalfields-plan-1800.jpg"
          :canZoom="true" />
      </ContentSection> 
  
    </div>

    <Pagination
      prevLabel="Painting"
      nextLabel="Other Mediums"
      prevRoute="Painting"
      nextRoute="Mediums" />


    <Footer />
  </div>
</template>

<script>
import SurveyMasthead from '@/components/SurveyMasthead.vue'
import Footer from '@/components/Footer.vue'
import Pagination from '@/components/Pagination.vue'
import ContentSection from '@/components/ContentSection.vue'
import ProjectImage from '@/components/ProjectImage.vue'

export default {
  name: 'Architecture',
  components: {
    SurveyMasthead,
    Footer,
    Pagination,
    ContentSection,
    ProjectImage
  },
}
</script>

<style lang="scss" scoped>
  .Architecture {
    background: #fff;
  }
</style>
